/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Agent_Notice_RefusedInputs */



/**
* | output |
* | --- |
* | "The agent can't help with this request." |
*
* @param {Assistant_Agent_Notice_RefusedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_agent_notice_refused = /** @type {((inputs?: Assistant_Agent_Notice_RefusedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Agent_Notice_RefusedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'agent ne peut pas traiter cette demande.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Agent kann Ihnen bei dieser Anfrage nicht weiterhelfen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'agente non può aiutarvi con questa richiesta.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Агент не может помочь с этим запросом.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El agente no puede ayudar con esta solicitud.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("代理人无法协助处理此请求。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("担当者はこのリクエストに対応できません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एजेंट इस अनुरोध में सहायता नहीं कर सकता।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O agente não pode ajudar com esta solicitação.")
	return /** @type {LocalizedString} */ ("The agent can't help with this request.")
});